import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20geometric%20composition%20with%20flowing%20organic%20shapes%20in%20soft%20coral%20and%20cream%20tones%20clean%20elegant%20gradient%20background%20subtle%20texture%20modern%20artistic%20design%20professional%20digital%20art&width=1600&height=900&seq=hero-bg-17c&orientation=landscape"
          alt="17c.cn 一站式综合网络平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-[800px] mx-auto px-4 md:px-6 text-center">
        <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-white/20 text-white border border-white/30 backdrop-blur-sm mb-6">
          官方入口 · 安全可靠
        </span>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight mb-5">
          发现世界的精彩
          <br />
          <span className="text-accent-300">从 17c.cn 开始</span>
        </h2>
        <p className="text-base md:text-lg text-white/80 max-w-[600px] mx-auto mb-8 leading-relaxed">
          快速、安全、便捷的一站式综合网络平台，汇聚科技、生活、娱乐、财经等海量优质内容，随时随地发现精彩。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            了解更多
          </Link>
          <a
            href="#featured"
            className="px-8 py-3 text-sm font-medium rounded-full bg-white/15 text-white hover:bg-white/25 border border-white/30 transition-colors whitespace-nowrap"
          >
            浏览精选
          </a>
        </div>
      </div>
    </section>
  );
}